import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row align--center text-center py-2" }
const _hoisted_2 = { class: "flex xs12" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = { class: "row align--center text-center py-2" }
const _hoisted_5 = { class: "flex xs12" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = {
  key: 0,
  class: "flex xs12"
}
const _hoisted_8 = { class: "row align--center text-center py-2" }
const _hoisted_9 = { class: "flex xs12" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = { class: "row align--center text-center py-2" }
const _hoisted_12 = { class: "flex xs12" }
const _hoisted_13 = { class: "item" }

import { onMounted, reactive, ref } from "vue";
import { useStore } from "vuex";
import { VUEX_ACTIONS } from '@/codes/util/constants';
import { User } from "@/codes/gen/types";
import { version } from '@/../package.json';
import { ReactiveData } from "@/codes/types/MDOTypes";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userInfo = reactive<ReactiveData<User>>({ data: {} as User });
const appVersion = ref(version);
const store = useStore();

const isWebmaster = ref(store.getters.isWebmaster);

onMounted(() => {
  store.subscribeAction({
    after: (action) => {
      if (action.type === VUEX_ACTIONS.setUserInfo) {
        userInfo.data = action.payload as User;
        isWebmaster.value = store.getters.isWebmaster;
      }
    }
  });
});

function logout() {
  store.dispatch(VUEX_ACTIONS.logout);
  router.push({ name: 'login' });
}

function changeAccount() {
  store.dispatch(VUEX_ACTIONS.showSelectAccount);
}


return (_ctx: any,_cache: any) => {
  const _component_va_button = _resolveComponent("va-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('userData.user')) + " " + _toDisplayString(_unref(userInfo).data.username), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('userData.account')) + " " + _toDisplayString(_unref(userInfo).data.sessionAccount?.name), 1)
      ]),
      (isWebmaster.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_va_button, {
              color: "gray",
              class: "mt-2",
              onClick: changeAccount
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('auth.changeAccount')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('userData.version')) + " " + _toDisplayString(appVersion.value), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_va_button, {
            color: "info",
            class: "px-4",
            onClick: logout
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('auth.logout')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}
}

})